"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _moment = _interopRequireDefault(require("moment"));
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _word = _interopRequireDefault(require("./word"));
var _sentence = _interopRequireDefault(require("./sentence"));
var _card_state = _interopRequireDefault(require("./card_state"));
var _card_rule = _interopRequireDefault(require("./card_rule"));
var _card_type = _interopRequireDefault(require("./card_type"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _exercise = _interopRequireDefault(require("./exercise"));
var _user_basic = _interopRequireDefault(require("./user_basic"));
var _card_word_association = _interopRequireDefault(require("./card_word_association"));
var _multiple_choice_option = _interopRequireDefault(require("./multiple_choice_option"));
var _spaced_repetition = _interopRequireDefault(require("./spaced_repetition"));
var _concept = _interopRequireDefault(require("./concept"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Card = (_dec = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_card_word_association["default"]))), _dec2 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_multiple_choice_option["default"]))), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_card_rule["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_card_type["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_sentence["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_concept["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_exercise["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.object)(_user_basic["default"])), _dec10 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return (0, _utils.isPresent)(item) ? new _date_decorator["default"](item) : null;
})), _dec11 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _class = /*#__PURE__*/function (_RootModel) {
  function Card() {
    var _this;
    _classCallCheck(this, Card);
    _this = _callSuper(this, Card);
    _initializerDefineProperty(_this, "forceReviewAfterDue", _descriptor, _this);
    _initializerDefineProperty(_this, "isEnriched", _descriptor2, _this);
    _initializerDefineProperty(_this, "reviewCardId", _descriptor3, _this);
    _initializerDefineProperty(_this, "cardsCount", _descriptor4, _this);
    _initializerDefineProperty(_this, "difficultyScore", _descriptor5, _this);
    _initializerDefineProperty(_this, "id", _descriptor6, _this);
    _initializerDefineProperty(_this, "position", _descriptor7, _this);
    _initializerDefineProperty(_this, "prompt", _descriptor8, _this);
    _initializerDefineProperty(_this, "interjection", _descriptor9, _this);
    _initializerDefineProperty(_this, "interjectionCode", _descriptor10, _this);
    _initializerDefineProperty(_this, "lastInSegment", _descriptor11, _this);
    _initializerDefineProperty(_this, "retired", _descriptor12, _this);
    _initializerDefineProperty(_this, "exerciseId", _descriptor13, _this);
    _initializerDefineProperty(_this, "consecutiveGoodScores", _descriptor14, _this);
    _initializerDefineProperty(_this, "frontText", _descriptor15, _this);
    _initializerDefineProperty(_this, "backText", _descriptor16, _this);
    _initializerDefineProperty(_this, "userSubmission", _descriptor17, _this);
    _initializerDefineProperty(_this, "requestVideoConversion", _descriptor18, _this);
    _initializerDefineProperty(_this, "introduction", _descriptor19, _this);
    _initializerDefineProperty(_this, "source", _descriptor20, _this);
    _initializerDefineProperty(_this, "sourceCardId", _descriptor21, _this);
    _initializerDefineProperty(_this, "sourceDeckId", _descriptor22, _this);
    _initializerDefineProperty(_this, "cardTypeId", _descriptor23, _this);
    _initializerDefineProperty(_this, "repetitionInterval", _descriptor24, _this);
    _initializerDefineProperty(_this, "easinessFactor", _descriptor25, _this);
    _initializerDefineProperty(_this, "viewsCount", _descriptor26, _this);
    _initializerDefineProperty(_this, "hadPositiveScore", _descriptor27, _this);
    _initializerDefineProperty(_this, "lastScore", _descriptor28, _this);
    _initializerDefineProperty(_this, "reviewsCount", _descriptor29, _this);
    _initializerDefineProperty(_this, "rejectedAsWord", _descriptor30, _this);
    _initializerDefineProperty(_this, "showNoteBeforeReveal", _descriptor31, _this);
    _initializerDefineProperty(_this, "note", _descriptor32, _this);
    _initializerDefineProperty(_this, "deckId", _descriptor33, _this);
    _initializerDefineProperty(_this, "pronoun", _descriptor34, _this);
    _initializerDefineProperty(_this, "tenseConceptId", _descriptor35, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor36, _this);
    _initializerDefineProperty(_this, "grammarTipMd", _descriptor37, _this);
    _initializerDefineProperty(_this, "grammarTip", _descriptor38, _this);
    _initializerDefineProperty(_this, "grammarTipTitle", _descriptor39, _this);
    _initializerDefineProperty(_this, "underlinedCharacters", _descriptor40, _this);
    _initializerDefineProperty(_this, "interfaceSource", _descriptor41, _this);
    _initializerDefineProperty(_this, "cardWordAssociations", _descriptor42, _this);
    _initializerDefineProperty(_this, "multipleChoiceOptions", _descriptor43, _this);
    _initializerDefineProperty(_this, "cardRule", _descriptor44, _this);
    _initializerDefineProperty(_this, "cardType", _descriptor45, _this);
    _initializerDefineProperty(_this, "sentence", _descriptor46, _this);
    _initializerDefineProperty(_this, "concept", _descriptor47, _this);
    _initializerDefineProperty(_this, "word", _descriptor48, _this);
    _initializerDefineProperty(_this, "exercise", _descriptor49, _this);
    _initializerDefineProperty(_this, "user", _descriptor50, _this);
    _initializerDefineProperty(_this, "reviewAfter", _descriptor51, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor52, _this);
    _this.cardState = new _card_state["default"](_this);
    return _this;
  }
  _inherits(Card, _RootModel);
  return _createClass(Card, [{
    key: "hasCardRule",
    get: function get() {
      return (0, _utils.isPresent)(this.cardRule);
    }
  }, {
    key: "isLastCard",
    get: function get() {
      return this.interjectionCode === 'END_OF_DECK';
    }
  }, {
    key: "sourceText",
    get: function get() {
      if (this.sentence) {
        var _this$sentence$defaul;
        return (_this$sentence$defaul = this.sentence.defaultSource) === null || _this$sentence$defaul === void 0 ? void 0 : _this$sentence$defaul.text;
      }
      if (this.word) {
        return this.word.vocabSourceList;
      }
    }
  }, {
    key: "backTextWithBr",
    get: function get() {
      var _this$backText;
      return (_this$backText = this.backText) === null || _this$backText === void 0 ? void 0 : _this$backText.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  }, {
    key: "translation",
    get: function get() {
      return (0, _utils.isPresent)(this.sentence) ? this.sentence : this.word;
    }
  }, {
    key: "translationType",
    get: function get() {
      return (0, _utils.isPresent)(this.sentence) ? 'Sentence' : 'Word';
    }
  }, {
    key: "translateCard",
    get: function get() {
      return this.cardTypeSlug === 'translate';
    }
  }, {
    key: "comprehendCard",
    get: function get() {
      return this.cardTypeSlug === 'comprehend';
    }
  }, {
    key: "commentsCount",
    get: function get() {
      if (this.word) {
        return this.word.commentsCount > 99 ? 99 : this.word.commentsCount;
      }
      if (this.sentence) {
        return this.sentence.commentsCount > 99 ? 99 : this.sentence.commentsCount;
      }
      return 0;
    }
  }, {
    key: "checkpointCard",
    get: function get() {
      return this.cardTypeSlug === 'checkpoint';
    }
  }, {
    key: "pluralCard",
    get: function get() {
      return this.cardTypeSlug === 'plural';
    }
  }, {
    key: "genderCard",
    get: function get() {
      return this.cardTypeSlug === 'gender';
    }
  }, {
    key: "interjectionCard",
    get: function get() {
      return this.cardTypeSlug === 'interjection';
    }
  }, {
    key: "conjugationCard",
    get: function get() {
      return ['conjugation-multiple-choice', 'conjugation-fill-in-blanks', 'conjugation'].includes(this.cardTypeSlug);
    }
  }, {
    key: "userResponseCard",
    get: function get() {
      return this.answerCard || this.describeCard;
    }
  }, {
    key: "describeCard",
    get: function get() {
      return this.cardTypeSlug === 'record_description';
    }
  }, {
    key: "exerciseCard",
    get: function get() {
      return this.cardTypeSlug === 'exercise';
    }
  }, {
    key: "answerCard",
    get: function get() {
      return this.cardTypeSlug === 'answer' || this.cardTypeSlug === 'record_answer';
    }
  }, {
    key: "triviaCard",
    get: function get() {
      return this.cardTypeSlug === 'trivia';
    }
  }, {
    key: "vocabWordComprehendCard",
    get: function get() {
      return this.cardTypeSlug === 'vocab_word_comprehend';
    }
  }, {
    key: "wordOptionsCard",
    get: function get() {
      return this.cardTypeSlug === 'vocab_word_options';
    }
  }, {
    key: "minimalPairCard",
    get: function get() {
      return this.cardTypeSlug === 'minimal_pair' || this.cardTypeSlug === 'sound_minimal_pair';
    }
  }, {
    key: "vocabWordTranslateCard",
    get: function get() {
      return this.cardTypeSlug === 'vocab_word_translate';
    }
  }, {
    key: "numberTranslateCard",
    get: function get() {
      return this.cardTypeSlug === 'number_translate';
    }
  }, {
    key: "vocabSentenceTranslateCard",
    get: function get() {
      return this.cardTypeSlug === 'vocab_sentence_translate';
    }
  }, {
    key: "vocabSentenceComprehendCard",
    get: function get() {
      return this.cardTypeSlug === 'vocab_sentence_comprehend';
    }
  }, {
    key: "difficultyLabel",
    get: function get() {
      if (this.difficultyScore <= 10) {
        return 'Very Easy';
      } else if (this.difficultyScore <= 25) {
        return 'Easy';
      } else if (this.difficultyScore <= 50) {
        return 'Moderate';
      } else if (this.difficultyScore <= 70) {
        return 'Hard';
      }
      return 'Very Hard';
    }
  }, {
    key: "difficultyColor",
    get: function get() {
      if (this.difficultyScore <= 25) {
        return _constants.Theme.green;
      } else if (this.difficultyScore <= 50) {
        return _constants.Theme.orange;
      }
      return _constants.Theme.red;
    }
  }, {
    key: "vocabTopBackground",
    value: function vocabTopBackground(isNative, masculineGenderColor, feminineGenderColor, neuterGenderColor) {
      if (this.word && this.word.definiteArticle && this.word.isNoun) {
        var color;
        if (this.word.gender === 'masculine') {
          color = masculineGenderColor;
        } else if (this.word.gender == 'feminine') {
          color = feminineGenderColor;
        } else {
          color = neuterGenderColor;
        }
        return _constants.Constants.COLORS[color];
      }
      return _constants.Theme.darkestBlue;
    }
  }, {
    key: "translationId",
    get: function get() {
      return this.translation ? this.translation.id : null;
    }
  }, {
    key: "hasCardType",
    get: function get() {
      return (0, _utils.isPresent)(this.cardType);
    }
  }, {
    key: "wordAssociationIds",
    get: function get() {
      return this.cardWordAssociations.map(function (item) {
        return item.wordAssociationId;
      });
    }
  }, {
    key: "cardRuleId",
    get: function get() {
      return this.hasCardRule ? this.cardRule.id : null;
    }
  }, {
    key: "targetVideoClip",
    get: function get() {
      return this.translation && this.translation.target && this.translation.target.videoClip;
    }
  }, {
    key: "hasTargetVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.targetVideoClip);
    }
  }, {
    key: "hasSupplementVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.supplementVideoClip);
    }
  }, {
    key: "supplementVideoClip",
    get: function get() {
      return this.sentence && this.sentence.videoClip || {};
    }
  }, {
    key: "showSupplement",
    get: function get() {
      return this.hasCardRule && this.cardRule.showSupplement;
    }
  }, {
    key: "hasSupplementImage",
    get: function get() {
      return this.sentence && this.sentence.hasImage;
    }
  }, {
    key: "supplementImage",
    get: function get() {
      return this.sentence && this.sentence.image;
    }
  }, {
    key: "cardTypeSlug",
    get: function get() {
      if (this.hasCardType) {
        return this.cardType.slug;
      }
      if (this.hasCardRule) {
        return this.cardRule.cardType && this.cardRule.cardType.slug;
      }
      return null;
    }
  }, {
    key: "hasTranslation",
    get: function get() {
      return (0, _utils.isPresent)(this.translation) && (0, _utils.isPresent)(this.translation.id);
    }
  }, {
    key: "setWord",
    value: function setWord(word) {
      this.word = word;
      this.isEnriched = true;
    }
  }, {
    key: "setSentence",
    value: function setSentence(sentence) {
      this.sentence = sentence;
      this.isEnriched = true;
    }
  }, {
    key: "onResetReview",
    value: function onResetReview() {
      _spaced_repetition["default"].onResetSpacedRepetition(this);
      this.difficultyScore = 25;
      this.retired = false;
    }
  }, {
    key: "processScore",
    value: function processScore(score, forceReviewAfterDue) {
      this.forceReviewAfterDue = forceReviewAfterDue;
      if (score === _constants.Constants.BAD_SCORE) {
        this.lastScore = 0;
        this.repetitionInterval = 0;
        this.consecutiveGoodScores = 0;
        this.reviewAfter = new _date_decorator["default"]((0, _moment["default"])(new Date()).add(1, 'minutes').toDate());
      } else {
        this.repetitionInterval = _spaced_repetition["default"].processRecallResult(score, this, true, forceReviewAfterDue);
        var hours = this.repetitionInterval * 24;
        this.reviewAfter = new _date_decorator["default"]((0, _moment["default"])(new Date()).add(hours, 'hours').toDate());
        this.lastScore = score;
        this.hadPositiveScore = true;
        this.consecutiveGoodScores += 1;
      }
      this.viewsCount += 1;
    }
  }, {
    key: "reviewInterval",
    value: function reviewInterval(score, forceReviewAfterDue) {
      this.forceReviewAfterDue = forceReviewAfterDue;
      if (score === _constants.Constants.BAD_SCORE) {
        return _constants.Constants.REVIEW_BAD_SCORE_IN_MINUTES;
      }
      return _spaced_repetition["default"].processRecallResult(score, this, null, this.forceReviewAfterDue);
    }
  }, {
    key: "formattedReviewInterval",
    value: function formattedReviewInterval(score, forceReviewAfterDue) {
      var number = this.reviewInterval(score, forceReviewAfterDue);
      return "".concat(number, " ").concat(score === _constants.Constants.BAD_SCORE ? 'minute' : 'day').concat(number > 1 ? 's' : '');
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "forceReviewAfterDue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEnriched", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "reviewCardId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "difficultyScore", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "prompt", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "interjection", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "interjectionCode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "lastInSegment", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "retired", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "exerciseId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "consecutiveGoodScores", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "frontText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "backText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "userSubmission", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "requestVideoConversion", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "introduction", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "source", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "sourceCardId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "sourceDeckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "cardTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "repetitionInterval", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "easinessFactor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "viewsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "hadPositiveScore", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "lastScore", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "reviewsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "rejectedAsWord", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "showNoteBeforeReveal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "note", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "deckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "pronoun", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "tenseConceptId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "grammarTipMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "grammarTip", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "grammarTipTitle", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "underlinedCharacters", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "interfaceSource", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "cardWordAssociations", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "multipleChoiceOptions", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "cardRule", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "cardType", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "sentence", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "concept", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "reviewAfter", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasCardRule", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCardRule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLastCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sourceText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backTextWithBr", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "backTextWithBr"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translationType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translationType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "comprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "comprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "commentsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "commentsCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkpointCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkpointCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "interjectionCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "interjectionCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userResponseCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userResponseCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "describeCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "describeCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answerCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answerCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordComprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordComprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordOptionsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordOptionsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minimalPairCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "minimalPairCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceComprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceComprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "difficultyLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "difficultyLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "difficultyColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "difficultyColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabTopBackground", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "vocabTopBackground"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translationId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translationId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordAssociationIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordAssociationIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardRuleId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardRuleId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTargetVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTargetVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSupplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSupplementVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSupplement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSupplement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSupplementImage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSupplementImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementImage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTypeSlug", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTypeSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSentence", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onResetReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onResetReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processScore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "processScore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewInterval", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reviewInterval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedReviewInterval", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "formattedReviewInterval"), _class.prototype), _class);
var _default = exports["default"] = Card;